module.exports = __webpack_public_path__ + "static/media/IMG_1790.2896bca2.JPG";